const __request = require(`./__request/__request_contentType_form`);

// 手续费率查询
// 接口文档地址：http://183.58.24.99:9999/swagger-ui.html?tdsourcetag=s_pcqq_aiomsg#/
const rate = (pParameter) => {
  if (!pParameter) pParameter = {};
  pParameter = {
    method: 'post',
    urlSuffix: '/flight/platform/commission/rate',
    data: {
    }
  }

  return __request(pParameter)
}
module.exports = rate;
